import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import styles from './style.styl'

const PROFILE_ICON_SVG = require('!svg-inline?removeTags=true&removeSVGTagAttrs=false!./menu-icon.svg')
const DISMISS_ICON_SVG = require('!svg-inline?removeTags=true&removeSVGTagAttrs=false!./dismiss.svg')

const ProfileIconPropTypes = {
  onClick: PropTypes.func,
}
function iconComponentFactory(name, src, defaultProps) {
  if (name && src === undefined) {
    src = name
    name = null
  }
  const Icon = ({ className, style, onClick, ...rest }) => (
    <IconSVG
      {...rest}
      style={style}
      className={cx(styles.Icon, className)}
      element='div'
      onClick={onClick}
      src={src}
    />
  )
  if (name) {
    Icon.displayName = `Icon(${name})`
  }
  Icon.defaultProps = { ...defaultProps }
  Icon.propTypes = { ...ProfileIconPropTypes }
  return Icon
}

export const ProfileIcon = iconComponentFactory('Profile', PROFILE_ICON_SVG)
export const DismissIcon = iconComponentFactory(
  'Dismiss',
  DISMISS_ICON_SVG,
  { className: styles.DismissIcon },
)




// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/icons/index.js